<ng-container *ngIf="knowledgeBaseService.workplaceSelectionData()  as data">
    <ng-container *ngIf="data.length === 0">
        Ein Fehler ist aufgetreten...
        <button routerLink="/dashboard" class="btn btn-qundis-primary">Zurück zum Dashboard</button>
    </ng-container>
  <!-- productionLine selection -->
  <ng-container *ngIf="isProductionLineArray(data)">
    <mat-card
      *ngFor="let item of data"
      class="my-3 p-2 cursor-pointer"
      (click)="selectOption(item)"
    >
      <div class="d-flex justify-content-between">
        <div class="card-text">{{ item.name }}</div>
        <div class="select-icon"><i class="bi bi-chevron-right"></i></div>
      </div>
    </mat-card>
  </ng-container>

  <!-- workplace selection -->
  <ng-container *ngIf="isWorkstationArray(data); else getBack">
    <mat-card
      *ngFor="let item of data"
      class="my-3 p-2 cursor-pointer"
      (click)="selectOption(item)"
    >
      <div class="d-flex justify-content-between">
        <div class="card-text">
          {{ item.name }}
        </div>
        <div class="select-icon"><i class="bi bi-chevron-right"></i></div>
      </div>
    </mat-card>
  </ng-container>

  <ng-template #getBack> </ng-template>
</ng-container>

